export const REQUEST_DIALOG_DEMO_TITLE = (
	<>
		Запишитесь
		<br />
		на&nbsp;бесплатное демо
	</>
);
export const REQUEST_DIALOG_DEMO_DESCRIPTION = (
	<>Оставьте свои контактные данные, и&nbsp;мы&nbsp;проведем для вас демонстрацию</>
);
export const REQUEST_DIALOG_DEMO_BUTTON_TEXT = 'Записаться на демо';

export const REQUEST_DIALOG_QUESTION_TITLE = (
	<>Заполните форму, и&nbsp;мы&nbsp;подберем вам решение под ваши задачи</>
);
export const REQUEST_DIALOG_QUESTION_DESCRIPTION = <></>;
export const REQUEST_DIALOG_QUESTION_BUTTON_TEXT = 'Отправить';

export const REQUEST_DIALOG_CONNECTION_TITLE = <>Есть вопросы по&nbsp;подключению?</>;
export const REQUEST_DIALOG_CURRENCY_TITLE = (
	<>
		Оставьте заявку, если хотели&nbsp;бы оплатить тариф не&nbsp;в&nbsp;рублях, а&nbsp;в&nbsp;другой валюте
	</>
);
export const REQUEST_DIALOG_CONNECTION_DESCRIPTION = (
	<>
		Не&nbsp;знаете, какой вариант выбрать и&nbsp;как подключить? Оставьте свои контактные данные,
		и&nbsp;мы&nbsp;вам поможем
	</>
);
export const REQUEST_DIALOG_CONNECTION_BUTTON_TEXT = 'Записаться на\u00A0демо';

export const REQUEST_DIALOG_PARTNERS_TITLE = <>Оставьте заявку, чтобы стать партнером</>;
export const REQUEST_DIALOG_PARTNERS_BUTTON_TEXT = 'Стать партнером';

export const REQUEST_DIALOG_PARTNERS_PRESENTATION_TITLE = <>Оставьте заявку, чтобы получить презентацию</>;
export const REQUEST_DIALOG_PARTNERS_PRESENTATION_COMMENT_TEXT = 'Хочу получить презентацию';
export const REQUEST_DIALOG_PARTNERS_PRESENTATION_BUTTON_TEXT = 'Получить';

export const REQUEST_DIALOG_PRODUCTS_TITLE = (
	<>Оставьте заявку, чтобы узнать больше о&nbsp;продуктах платформы</>
);
export const REQUEST_DIALOG_PARTNERS_PRODUCTS_COMMENT_TEXT = 'Хочу узнать больше о\u00A0продуктах платформы';
export const REQUEST_DIALOG_PARTNERS_PRODUCTS_BUTTON_TEXT = 'Узнать';

export const REQUEST_DIALOG_PROMOTION_TITLE =
	'Оставьте заявку и\u00A0мы\u00A0подключим вам сервисы бесплатно на\u00A03\u00A0месяца';
export const REQUEST_DIALOG_PROMOTION_DESCRIPTION = '';
export const REQUEST_DIALOG_PROMOTION_BUTTON_TEXT = 'Подключить';
export const REQUEST_DIALOG_PROMOTION_DISCLAIMER_TEXT =
	'Нажимая на\u00A0кнопку «Подключить», вы\u00A0принимаете условия акции и\u00A0даете организатору согласие на\u00A0обработку персональных данных в\u00A0соответствии с\u00A0условиями акции';
export const REQUEST_DIALOG_PRODUCTS_COMMENT_TEXT = 'Хочу узнать больше о\u00A0продуктах платформы';
export const REQUEST_DIALOG_PRODUCTS_BUTTON_TEXT = 'Узнать';

export const REQUEST_DIALOG_WORKSPACE_TITLE =
	'Оставьте заявку, и\u00A0мы\u00A0подберем решение для вашей задачи';
export const REQUEST_DIALOG_WORKSPACE_PROMO_TITLE =
	'Оставьте заявку и\u00A0мы\u00A0подключим вам сервисы со\u00A0скидкой\u00A050%';
export const REQUEST_DIALOG_WORKSPACE_BUTTON_TEXT = 'Оставить заявку';

export const REQUEST_DIALOG_DISK_O_CONNECTION_TITLE = 'Заявка на\u00A0подключение';
export const REQUEST_DIALOG_DISK_O_CONNECTION_DESCRIPTION =
	'Оставьте заявку и\u00A0мы\u00A0свяжемся с\u00A0вами по\u00A0поводу участия в\u00A0акции';
export const REQUEST_DIALOG_DISK_O_CONNECTION_BUTTON_TEXT = 'Подключить';
